import { Action } from 'redux';

export interface SessionState {
  loadingSession: boolean;
  loadingLogin: boolean;
  logged: boolean;
  failed: string | null;
  error: boolean;
  user: any;
  selectedChurchIndex: number | any;
}

export enum SessionActionTypes {
  SESSION_START = '@@login/SESSION_START',
  SESSION_SUCCESS = '@@login/SESSION_SUCCESS',
  SESSION_FAIL = '@@login/SESSION_FAIL',
  LOGIN_START = '@@login/LOGIN_START',
  LOGIN_FAIL = '@@login/LOGIN_FAIL',
  LOGIN_ERROR = '@@login/LOGIN_ERROR',
  LOGIN_SUCCESS = '@@login/LOGIN_SUCCESS',
  LOGOUT = '@@login/LOGOUT',
  CHANGE_CHURCH = '@@login/CHANGE_CHURCH',
}

export interface SessionAction extends Action<SessionActionTypes> {
  user?: any;
  selectedChurchIndex?: number;
  failed?: string;
}
